import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  Output,
} from '@angular/core';

import { DndDirective } from 'src/app/shared/directives/dnd.directive';
import { AlertService } from 'src/app/shared/services';

declare var $: any;

@Component({
    selector: 'app-upload-dialog',
    templateUrl: './upload-dialog.component.html',
    styleUrls: ['./upload-dialog.component.scss'],
    viewProviders: [DndDirective],
    standalone: false
})
export class UploadDialogComponent {
  @HostListener('window:popstate', ['$event'])
  onPopState(event: Event): void {
    this.fnCloseUploadModal();
  }
  @Output() submitClick = new EventEmitter();
  @Output() sampleDownload = new EventEmitter();
  @Output() modalClosed = new EventEmitter();
  @Input() heading: string = 'Upload List';
  @Input() showNote: boolean = false;
  @Input()
  footerNote: string =
    'Mandatory columns should be present (email and designations)';
  @Input() isSampleExcelVisible: boolean = true;

  file: any = [];
  disableUpload: boolean = false;
  errorMessage: string = '';

  constructor(private alertService: AlertService) {}

  openModal() {
    this.alertService.clear();
    $('#uploadDocumentsModal').modal('show');
  }

  fnCloseUploadModal() {
    $('#uploadDocumentsModal').modal('hide');
    this.file = [];
    this.modalClosed.emit();
  }

  onFileDropped(event: any) {
    this.prepareFilesList(event);
  }

  fileBrowseHandler(files: any) {
    this.prepareFilesList(files.target.files);
  }

  deleteFile() {
    this.file = [];
  }

  prepareFilesList(file: any) {
    this.file = [];

    for (const item of file) {
      this.file.push(item);
    }

    this.invalidFile(this.file[0].size, this.file[0].name);
  }

  formatBytes(bytes: any, decimals: any) {
    if (bytes === 0) {
      return '0 Bytes';
    }

    const k = 1024;
    const dm = decimals <= 0 ? 0 : decimals || 2;

    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }

  isFileExtensionValid(fileName: string) {
    const supportedExtensions = ['.xlsx'];

    const fileExtension = this.getFileExtension(fileName);

    return supportedExtensions.includes(fileExtension)
      ? null
      : 'Only XLSX are allowed.';
  }

  invalidFile(fileSize: number, fileName: string) {
    const errorMessage =
      this.isSizeError(fileSize) || this.isFileExtensionValid(fileName);

    if (errorMessage) {
      this.disableUpload = true;
      this.errorMessage = errorMessage;
    } else {
      this.disableUpload = false;
      this.errorMessage = '';
    }
  }

  isSizeError(fileSize: number) {
    const maxSize = 10 * 1024 * 1024;

    return fileSize > maxSize ? 'Max size allowed is 10MB.' : null;
  }

  getFileExtension(fileName: string): string {
    const dotIndex = fileName.lastIndexOf('.');

    if (dotIndex === -1) {
      return '';
    }

    return fileName.substring(dotIndex).toLowerCase();
  }

  fnOnSubmit() {
    const sizeError = this.isSizeError(this.file[0].size);

    if (sizeError) {
      return;
    }
    let formData = new FormData();

    formData.append('file', this.file[0]);
    this.submitClick.emit(formData);
  }

  fnDownloadSample() {
    this.sampleDownload.emit();
  }
}
